import { render, staticRenderFns } from "./greenDetail.vue?vue&type=template&id=cfab0514"
import script from "./greenDetail.vue?vue&type=script&lang=js"
export * from "./greenDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports